// A single extracted clip is reused across all model attempts.
import * as crypto from "node:crypto";
import * as fs from "node:fs";
import { z } from "zod";
import { CLIP_FPS, cutClip } from "./clip.js";
import { generateReviewJson, type ReviewModelConfig } from "../models.js";
import type { UsageRow } from "../agent.js";

const SYSTEM = "你是剧本审核的视频证据核对器。只报告视频窗口中可直接观察或听到的事实；"
  + "无法确认时明确说明，不推测剧情。";

export interface WatchUsage extends UsageRow {
  trace_key: string; clip_bytes: number; wall_ms: number;
}
export interface WatchResult { answer: string; usage: WatchUsage[] }
export interface WatchOptions extends ReviewModelConfig { callKey: string }

export function traceKey(video: string, window: string, model: string, question: string): string {
  return "watch:" + crypto.createHash("sha256")
    .update([video, window, model, question].join("\n")).digest("hex");
}

export async function watchWindow(
  video: string, from: string, to: string, question: string, opts: WatchOptions,
): Promise<WatchResult> {
  const clip = await cutClip(video, from, to);
  const started = Date.now();
  try {
    const result = await generateReviewJson({ config: opts, prompt: question, system: SYSTEM,
      video: { data: fs.readFileSync(clip.path, "base64"), fps: CLIP_FPS },
      schema: z.object({ answer: z.string().min(1) }), timeoutMs: 180_000, maxOutputTokens: 2048, callKey: opts.callKey });
    return { answer: result.value.answer, usage: result.usage.map((row) => ({
      ...row, trace_key: traceKey(video, `${from}..${to}`, row.model, question),
      clip_bytes: clip.bytes, wall_ms: Date.now() - started,
    })) };
  } finally {
    clip.cleanup();
  }
}
